
import PageHero from '../../../components/base/PageHero';

const ContactHeroSection: React.FC = () => {
  return (
    <PageHero
      breadcrumb="Contact Us"
      label="Get In Touch"
      title="Let's Build Something Together"
      description="Whether you need a training quote, SETA compliance guidance, or just want to explore our programmes — our team is ready to help within 24 hours."
    />
  );
};

export default ContactHeroSection;
